import { Result } from "antd";
import { ConfigStepId, ConfigStepType } from "../utils/configuration";
import ApplicantInfo from "./organisms/ApplicantInfo";
import Complete from "./organisms/Complete";
import Welcome from "./organisms/Welcome";
import Transcript from "./organisms/Transcript";
import Business from "./organisms/Business";

interface StepParams {
    step: ConfigStepType;
    onContinue: () => void;
}

const Step = ({
    step,
    onContinue,
}: StepParams) => step.id === ConfigStepId.welcome
        ? <Welcome {...step.params} />
        : step.id === ConfigStepId.complete
            ? <Complete />
            : step.id === ConfigStepId.info
                ? <ApplicantInfo {...step.params} onContinue={onContinue} />
                : step.id === ConfigStepId.transcript
                    ? <Transcript {...step.params} />
                    : step.id === ConfigStepId.business
                        ? <Business {...step.params} />
                        : <Result status={404} />;

export default Step;
